import {useNavigate} from 'react-router-dom';

import {CardBox} from '@shared/components';
import {ROUTE__PARTICIPANTS} from '@shared/constants';
import {Header} from '@widgets/common';
import {EditParticipantForm} from '@widgets/participant/EditParticipantForm';

import {COLOR__WHITE} from '@/theme/colors';

export const CreateParticipantPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header title="Create participant" mb={1} />

      <CardBox bgcolor={COLOR__WHITE}>
        <EditParticipantForm onCreated={() => navigate(ROUTE__PARTICIPANTS)} />
      </CardBox>
    </>
  );
};
